// Test script loading

document.addEventListener('DOMContentLoaded', function() {
  
  const CONFIG = {
    MOBILE_BREAKPOINT: 600,
    SUCCESS_DELAY: 500,
    ERROR_DELAY: 2000
  };

  let productData = null;
  let selectedVariant = null;

  // Initialize mobile quick buy system
  
  if (typeof window.productData !== 'undefined') {
    productData = window.productData;
    bindEvents();
    toggleVisibility();
  }

  function bindEvents() {
    // Window events
    window.addEventListener('load', toggleVisibility);
    window.addEventListener('resize', toggleVisibility);
    window.addEventListener('scroll', toggleVisibility);
    
    // Mobile quick buy button
    const mobileBtn = document.querySelector('.mobile-quick-buy__btn');
    if (mobileBtn) {
      mobileBtn.addEventListener('click', openSizeSelector);
    }
    
    // Size selector items (delegated event on container)
    const sizeSelectorList = document.querySelector('.size-selector__list');
    if (sizeSelectorList) {
      sizeSelectorList.addEventListener('click', function(e) {
        if (e.target.closest('.size-selector__item')) {
          selectSize(e);
        }
      });
    }
    
    // Size selector overlay click
    const sizeSelector = document.querySelector('.size-selector');
    if (sizeSelector) {
      sizeSelector.addEventListener('click', function(e) {
        if (e.target === this) closeSizeSelector();
      });
    }
    
    
    // Update button text based on product type
    updateButtonText();
  }

  function toggleVisibility() {
    
    const mobileBtn = document.querySelector('.mobile-quick-buy');
    const originalBtn = document.querySelector('.add-to-cart');
    
    if (window.innerWidth <= CONFIG.MOBILE_BREAKPOINT) {
      // Inline the viewport check
      let isOutOfViewport = false;
      if (originalBtn) {
        const rect = originalBtn.getBoundingClientRect();
        const buttonTop = rect.top + window.scrollY;
        const buttonBottom = buttonTop + originalBtn.offsetHeight;
        const viewportTop = window.scrollY;
        const viewportBottom = viewportTop + window.innerHeight;
        isOutOfViewport = buttonBottom < viewportTop || buttonTop > viewportBottom;
      }
      
      const shouldShow = !originalBtn || !isElementVisible(originalBtn) || isOutOfViewport;
      
      if (mobileBtn) {
        if (shouldShow) {
          mobileBtn.classList.add('mobile-quick-buy--visible');
        } else {
          mobileBtn.classList.remove('mobile-quick-buy--visible');
        }
      }
    } else {
      if (mobileBtn) {
        mobileBtn.classList.remove('mobile-quick-buy--visible');
      }
    }
  }

  function isElementVisible(element) {
    return element.offsetWidth > 0 && element.offsetHeight > 0 && 
           window.getComputedStyle(element).display !== 'none' && 
           window.getComputedStyle(element).visibility !== 'hidden';
  }


  function getVariantSellingPlanId(variant) {
    return variant && variant.selling_plan_id ? variant.selling_plan_id : null;
  }



  function openSizeSelector() {
    const sizeSelector = document.querySelector('.size-selector');
    if (sizeSelector) {
      sizeSelector.classList.add('size-selector--visible');
    }
    showSelectedColor();
    populateSizes();
  }

  function closeSizeSelector() {
    const sizeSelector = document.querySelector('.size-selector');
    if (sizeSelector) {
      sizeSelector.classList.remove('size-selector--visible');
    }
  }

  function showSelectedColor() {
    const activeMetaPro = document.querySelector('.meta-pro.active:not(.hide)');
    const container = document.querySelector('.size-selector__selected-color');
    
    if (activeMetaPro && container) {
      const colorName = activeMetaPro.getAttribute('data-title');
      const metaProImg = activeMetaPro.querySelector('img');
      
      if (colorName && metaProImg) {
        const colorSwatch = document.querySelector('.size-selector__color-swatch');
        const colorNameElement = document.querySelector('.size-selector__color-name');
        
        if (colorSwatch) {
          colorSwatch.src = metaProImg.src;
          colorSwatch.alt = metaProImg.alt;
        }
        if (colorNameElement) {
          colorNameElement.textContent = colorName;
        }
        container.style.display = 'flex';
        return;
      }
    }
    
    if (container) {
      container.style.display = 'none';
    }
  }

  function getAllRelatedProducts() {
    if (typeof window.relatedProductsData !== 'undefined' && window.relatedProductsData) {
      return [
        ...(window.relatedProductsData.mateProducts || []),
        ...(window.relatedProductsData.seasonalProducts || []),
        ...(window.relatedProductsData.collaborationProducts || [])
      ];
    }
    return [];
  }

  function createSizeItemHTML(sizeValue, variant, status, dimensions) {
    let priceHTML = '';
    let statusHTML = '';
    let dimensionsHTML = '';
    let preorderHTML = '';
    
    if (variant) {
      priceHTML = `$${(variant.price / 100).toFixed(0)}`;
      
      // Check if this specific variant has selling plans (pre-order)
      if (variant.selling_plan_name) {
        const shippingText = variant.selling_plan_name.replace(/Pre-order:\s*/i, '');
        preorderHTML = `<span class="size-selector__preorder"> - ${shippingText}</span>`;
      }
    }
    
    if (status) {
      statusHTML = `<span class="size-selector__status">${status}</span>`;
    } else if (!variant) {
      // If no variant and no status provided, default to Unavailable
      statusHTML = `<span class="size-selector__status">Unavailable</span>`;
    }
    
    if (dimensions) {
      dimensionsHTML = `<span class="size-selector__dimensions">${dimensions}</span>`;
    }
    
    return `<span class="size-selector__name">${sizeValue} ${dimensionsHTML}</span><span class="size-selector__price">${priceHTML}${preorderHTML}</span>${statusHTML}`;
  }

  function populateSizes() {
    
    const list = document.querySelector('.size-selector__list');
    if (!list) {
      return;
    }
    
    
    // Clear existing content
    list.innerHTML = '';
    
    const variantOption = getSizeOption();
    const allVariants = getAllVariants();
    
    // Handle single variant products - show current variant + unavailable meta variants
    if (!variantOption && isSingleVariantProduct()) {
      populateSingleVariantWithMeta(list, allVariants);
      return;
    }
    
    // Handle products with variant options normally
    if (!variantOption) return;

    // Inline getExtendedSizes
    const extendedSizes = [...new Set([
      ...variantOption.values,
      ...allVariants.filter(v => v.options && v.options.length > 0).map(v => v.options[0])
    ])];
    
    extendedSizes.forEach(sizeValue => {
      const variantInfo = findVariantInfo(sizeValue, allVariants);
      const item = document.createElement('div');
      item.className = 'size-selector__item';
      item.setAttribute('data-size', sizeValue);
      
      if (variantInfo.currentVariant) {
        const dimensions = variantInfo.currentVariant.metafields?.custom?.large_dimensions;
        if (!variantInfo.currentVariant.available) {
          item.classList.add('sold-out');
          item.innerHTML = createSizeItemHTML(sizeValue, variantInfo.currentVariant, 'Sold Out', dimensions);
        } else {
          item.innerHTML = createSizeItemHTML(sizeValue, variantInfo.currentVariant, null, dimensions);
        }
      } else {
        item.classList.add('unavailable');
        item.innerHTML = createSizeItemHTML(sizeValue, null, 'Unavailable');
      }
      
      list.appendChild(item);
    });
  }

  function populateSingleVariantWithMeta(list, allVariants) {
    const currentVariant = productData.variants[0];
    const relatedProducts = getAllRelatedProducts();
    
    // Create a Set to collect all unique size values
    const allSizes = new Set();
    
    // Add current variant (use title or "One Size" if default)
    const currentVariantSize = currentVariant.title === 'Default Title' ? 'One Size' : currentVariant.title;
    allSizes.add(currentVariantSize);
    
    // Add sizes from related products (these will be unavailable for current product)
    relatedProducts.forEach(relatedProduct => {
      if (relatedProduct && relatedProduct.variants) {
        relatedProduct.variants.forEach(variant => {
          if (variant.options && variant.options.length > 0) {
            // Use the first option as size (usually size is option1)
            allSizes.add(variant.options[0]);
          }
        });
      }
    });
    
    // Convert to array and create items
    Array.from(allSizes).forEach(sizeValue => {
      const item = document.createElement('div');
      item.className = 'size-selector__item';
      item.setAttribute('data-size', sizeValue);
      
      // Check if this size matches current product variant
      if (sizeValue === currentVariantSize) {
        // This is the current product variant
        const dimensions = currentVariant.metafields?.custom?.large_dimensions;
        if (!currentVariant.available) {
          item.classList.add('sold-out');
          item.innerHTML = createSizeItemHTML(sizeValue, currentVariant, 'Sold Out', dimensions);
        } else {
          item.innerHTML = createSizeItemHTML(sizeValue, currentVariant, null, dimensions);
        }
      } else {
        // This is from related products - unavailable for current product
        item.classList.add('unavailable');
        item.innerHTML = createSizeItemHTML(sizeValue, null, 'Unavailable');
      }
      
      list.appendChild(item);
    });
  }

  function isSingleVariantProduct() {
    // Check if product has only one variant and no size options
    if (productData.variants.length !== 1) return false;
    
    const variant = productData.variants[0];
    const hasRealVariantOption = getSizeOption() !== null;
    
    // Check if the single variant has meaningful options (not just "Default Title")
    const hasDefaultTitle = variant.title === 'Default Title' || 
                           variant.options.includes('Default Title') ||
                           variant.options.every(option => option === variant.title);
    
    return !hasRealVariantOption && hasDefaultTitle;
  }


  function updateButtonText() {
    const btn = document.querySelector('.mobile-quick-buy__btn');
    if (!btn) return;
    
    if (isSingleVariantProduct()) {
      const variant = productData.variants[0];
      if (variant.available) {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      } else {
        btn.textContent = 'Sold Out';
        btn.disabled = true;
      }
    } else {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    }
  }

  function getSizeOption() {
    
    if (productData.options_with_values && productData.options_with_values.length > 0) {
     // DYNAMIC: Automatically takes the first option (Size, Style, Scent, etc.)
      const option = productData.options_with_values[0];
      return option;
    } else if (productData.options && productData.options.length > 0) {
      const allVariants = getAllVariants();
      const optionValues = [...new Set(allVariants.map(v => v.option1))];
      const option = { name: productData.options[0], values: optionValues };
      return option;
    }
    return null;
  }

  function getAllVariants() {
    const relatedProducts = getAllRelatedProducts();
    let allVariants = [...productData.variants];
    
    relatedProducts.forEach(relatedProduct => {
      if (relatedProduct && relatedProduct.variants) {
        allVariants = allVariants.concat(relatedProduct.variants);
      }
    });
    
    return allVariants;
  }

  function findVariantInfo(sizeValue, allVariants) {
    // Handle single variant products specially
    if (isSingleVariantProduct()) {
      const currentVariant = productData.variants[0];
      const currentVariantSize = currentVariant.title === 'Default Title' ? 'One Size' : currentVariant.title;
      
      if (sizeValue === currentVariantSize) {
        currentVariant._isCurrentProduct = true;
        return { currentVariant, relatedVariant: null };
      }
      // If it's not the current variant size, it's from related products (unavailable)
      return { currentVariant: null, relatedVariant: null };
    }
    
    // First search in current product
    const currentVariant = productData.variants.find(v => v.options.includes(sizeValue));
    if (currentVariant) {
      currentVariant._isCurrentProduct = true;
      return { currentVariant, relatedVariant: null };
    }

    // If not found, search in related products
    const relatedVariant = allVariants.find(v => v.options && v.options.includes(sizeValue));
    if (relatedVariant) {
      const sourceProduct = getAllRelatedProducts().find(p => 
        p.variants && p.variants.includes(relatedVariant)
      );
      relatedVariant._sourceProduct = sourceProduct;
      relatedVariant._isCurrentProduct = false;
      return { currentVariant: null, relatedVariant };
    }

    return { currentVariant: null, relatedVariant: null };
  }

  function selectSize(e) {
    const item = e.target.closest('.size-selector__item');
    if (!item) return;
    
    const sizeValue = item.getAttribute('data-size');
    
    // Handle unavailable/sold-out items - do nothing
    if (item.classList.contains('unavailable') || item.classList.contains('sold-out')) {
      return;
    }
    
    // Process available items
    item.classList.add('loading');
    const nameElement = item.querySelector('.size-selector__name');
    if (nameElement) {
      nameElement.textContent = 'Adding...';
    }
    
    updateMetaProVisibility(sizeValue);
    
    const allVariants = getAllVariants();
    const variantInfo = findVariantInfo(sizeValue, allVariants);
    const variant = variantInfo.currentVariant || variantInfo.relatedVariant;
    
    if (variant && variant._isCurrentProduct) {
      selectedVariant = variant;
      addToCart(item, sizeValue);
    } else {
      // Inline resetItemState
      item.classList.remove('loading');
      if (nameElement) {
        nameElement.textContent = sizeValue;
      }
    }
  }

  function updateMetaProVisibility(selectedSize) {
    document.querySelectorAll('.metapro .meta-pro-wrapper .meta-pro-wrapper-item').forEach(metaproItem => {
      const metaproVariantsGroup = metaproItem.querySelectorAll('.meta-pro');
      let isShowing = false;
      
      metaproVariantsGroup.forEach(metaproVariant => {
        metaproVariant.classList.add('hide');
        const variantTitle = metaproVariant.dataset.variantTitle;
        
        if ((!variantTitle && !isShowing) || variantTitle === selectedSize) {
          metaproVariant.classList.remove('hide');
          isShowing = true;
        }
      });
    });
  }



  function openDrawerDirectly() {
    // Method 1: Find and click existing cart button (fastest)
    const cartTrigger = document.querySelector('.js-drawer-open-cart');
    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }
    
    // Method 2: Find drawer and open directly (fallback)
    const drawer = document.querySelector('.drawer--cart');
    if (drawer) {
      drawer.classList.add('drawer--is-open');
      document.body.classList.add('js-drawer-open');
      return true;
    }
    
    // Method 3: Try other common drawer selectors
    const altDrawer = document.querySelector('[data-drawer="cart"], #CartDrawer');
    if (altDrawer) {
      altDrawer.classList.add('drawer--is-open', 'drawer--is-active');
      document.body.classList.add('js-drawer-open');
      return true;
    }
    
    return false;
  }

  function addToCart(item, sizeValue) {
    const btn = document.querySelector('.mobile-quick-buy__btn');
    if (!btn) return;
    
    const originalText = btn.textContent;
    
    btn.textContent = 'Adding...';
    btn.disabled = true;
    
    // Create form data
    const formData = new FormData();
    formData.append('id', selectedVariant.id);
    formData.append('quantity', 1);
    
    // Get selling plan ID directly from selected variant (independent of PDP state)
    const sellingPlanId = getVariantSellingPlanId(selectedVariant);
    
    if (sellingPlanId) {
      formData.append('selling_plan', sellingPlanId);
    }
    
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((cartItem) => {
      
      // Show immediate feedback
      btn.textContent = 'Added!';
      item.classList.remove('loading');
      const nameElement = item.querySelector('.size-selector__name');
      if (nameElement) {
        nameElement.textContent = 'Added!';
      }
      
      // Trigger the theme's cart update system using native events
      document.body.dispatchEvent(new CustomEvent('updateCart', {
        detail: cartItem,
        bubbles: true
      }));
      
      // Also try theme.cart._updateCart if available
      if (window.theme && window.theme.cart && typeof window.theme.cart._updateCart === 'function') {
        window.theme.cart._updateCart();
      }
      
      // Open drawer after a short delay to let cart update
      setTimeout(() => {
        openDrawerDirectly();
      }, 100);
      
      // Close modal after shorter delay
      setTimeout(() => {
        closeSizeSelector();
        btn.textContent = originalText;
        btn.disabled = false;
        // Reset item state
        const nameElement = item.querySelector('.size-selector__name');
        if (nameElement) {
          nameElement.textContent = sizeValue;
        }
      }, CONFIG.SUCCESS_DELAY);
    })
    .catch(() => {
      btn.textContent = 'Error - Try Again';
      btn.disabled = false;
      // Reset item state
      item.classList.remove('loading');
      const nameElement = item.querySelector('.size-selector__name');
      if (nameElement) {
        nameElement.textContent = sizeValue;
      }
      
      setTimeout(() => {
        btn.textContent = originalText;
      }, CONFIG.ERROR_DELAY);
    });
  }
});